import pathname, { menuType } from '../../../constants/pathname'

export const reviewPaymentSchema = [
  {
    alwaysOpenKeys: ['1'],
    menu: menuType.reviewPayment,
    sidebars: [
      {
        id: 'section1',
        type: 'nav',
        items: [
          {
            eventKey: '11',
            icon: {
              name: 'file-text-o',
            },
            link: pathname.admin.adminWithdrawalReview.sendWithdrawReview,
            children: 'การเบิกจ่ายค่าตอบแทนการทบทวนโครงการ',
          },
          {
            eventKey: '12',
            icon: {
              name: 'file-text-o',
            },
            link: pathname.admin.adminWithdrawalReview.sendWithdrawReviewByReviewer,
            children: 'การเบิกจ่ายค่าตอบแทนการทบทวนโครงการ (รายผู้ทรงฯ)',
          },
        ],
      },
    ],
  },
  {
    alwaysOpenKeys: ['2'],
    menu: menuType.reviewPayment,
    sidebars: [
      {
        id: 'section2',
        type: 'nav',
        items: [
          {
            eventKey: '21',
            icon: {
              name: 'file-text-o',
            },
            link: pathname.admin.adminWithdrawalReview.withdrawReview,
            children: 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ',
          },
          {
            eventKey: '22',
            icon: {
              name: 'file-text-o',
            },
            link: pathname.admin.adminWithdrawalReview.withdrawReviewByReviewer,
            children: 'อนุมัติเบิกจ่ายค่าตอบแทนการทบทวนโครงการ (รายผู้ทรงฯ)',
          },
        ],
      },
    ],
  },
]
